import React from "react";

const CommitteeTable = ({ data = [], searchTerm = "" }) => {
  // Filter data based on search bar input
  const filteredData = data.filter(item => 
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.designation.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.councilPosition.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Group items dynamically by their assigned sections
  const groupedSections = filteredData.reduce((acc, item) => {
    const sectionName = item.section || "Other Council Members";
    if (!acc[sectionName]) acc[sectionName] = [];
    acc[sectionName].push(item);
    return acc;
  }, {});

  // Simple selector to map icons based on group classification
  const renderSectionIcon = (section) => {
    if (section.toLowerCase().includes("management")) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
      );
    }
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"></path></svg>
    );
  };

  return (
    <div className="responsive-table-scroller">
      <table className="institutional-data-table">
        <thead>
          <tr>
     <th style={{ width: "8%" }}>SR. NO.</th>
<th style={{ width: "22%" }}>COUNCIL POSITION</th>
<th style={{ width: "30%" }}>NAME OF THE OFFICIAL</th>
<th style={{ width: "40%" }}>DESIGNATION</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(groupedSections).map((sectionName) => (
            <React.Fragment key={sectionName}>
              {/* Category Subheader row block */}
              <tr className="table-group-row-header">
                <td colSpan="4">
                  <div className="group-header-cell-content">
                    <span className="group-badge-icon">
                      {renderSectionIcon(sectionName)}
                    </span>
                    {sectionName}
                  </div>
                </td>
              </tr>
              {/* Sub-items list data */}
              {groupedSections[sectionName].map((row) => (
                <tr key={row.no} className="table-data-row">
                  <td className="text-center cell-srno">{row.no}</td>
                  <td className="font-semibold cell-position">{row.councilPosition}</td>
                  <td className="font-medium cell-name">{row.name}</td>
                  <td className="text-muted cell-designation">{row.designation}</td>
                </tr>
              ))}
            </React.Fragment>
          ))}
          {Object.keys(groupedSections).length === 0 && (
            <tr>
              <td colSpan="4" className="empty-state-cell">No matching members found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CommitteeTable;